import { editorModel } from '#packages/util';
import { isImpersonateDisabled } from './specs';

export const getIsImpersonated = () => {
  if (isImpersonateDisabled()) {
    return false;
  }

  return editorModel.isImpersonated;
};
